import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CollegeIAGPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    INFORMATION ADVICE AND GUIDANCE (IAG) POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Supporting learners and employers throughout their journey
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni Akindele Bakarey</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V14 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}><strong>ALL EMPLOYEES and FREELANCE STAFF</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Statement */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Policy Statement
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    DTK, as an approved ESFA provider of vocational learning, from entry level upwards, will provide an appropriate impartial Information Advice and Guidance service to potential candidates, current learners and employers at the initial contact, recruitment phase, whilst participating on programmes, and on exit from programmes.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Aims and Objectives of the DTK Information Advice and Guidance Service
                  </h4>

                  <div style={{ marginBottom: '30px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '15px' }}>
                      1. To provide impartial information advice and guidance to potential customers, candidates, existing learners, employers, and parents which:
                    </p>
                    <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px' }}>
                      <li>Results in retention and achievement rates of over 90%</li>
                      <li>Progression (intermediate to advanced apprenticeship) rates more than 20%</li>
                      <li>Applicant satisfaction survey results more than 95%</li>
                      <li>Learner satisfaction survey results more than 95%</li>
                      <li>Employer satisfaction survey results more than 95%</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '15px' }}>
                      2. All employers to:
                    </p>
                    <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px' }}>
                      <li>Have an initial aims and objectives meeting wherein current and planned legislation, sector updates, staff development, recruitment, and planned growth are discussed and both Training and Organisational needs analysis are completed.</li>
                      <li>Agree key performance indicators for each training post that will be incorporated into the delivery and for the duration of the training to be reviewed at agreed periods.</li>
                      <li>Receive information advice and guidance on their identified training needs to meet both their current and future training and development needs.</li>
                      <li>Plan and agree a bespoke delivery plan for their organisation and staff to cover the agreed term of their training award(s).</li>
                      <li>Take part and complete Health and Safety checks and risk assessments as well as liability insurance checks and then agree an action plan for any identified areas for concern.</li>
                      <li>Receive learner attendance, progression, and achievement reports at agreed points throughout the course (e.g., monthly, bi-monthly, quarterly etc).</li>
                      <li>Agree to take part in planned learner reviews every 10-12 weeks (or mid-point for shorter courses).</li>
                      <li>Complete online employer surveys as requested by DTK or ESFA.</li>
                      <li>Access learner E-portfolios/paper portfolios to support learner reviews, progress, attendance, achievement and provide signatures as requested.</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: '0' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '15px' }}>
                      3. All learners to:
                    </p>
                    <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px' }}>
                      <li>Have an individual interview discussing their career pathway and receive career information advice and guidance.</li>
                      <li>Undertake an enrolment session, including the diagnostic assessments for English, Maths, and ICT, Knowledge Skills and Behaviour assessments and prior attainment reviewed.</li>
                      <li>At induction, agree an Individual Learning Plan that accounts for their specific needs and pastoral support needs.</li>
                      <li>Have progress reviewed every 8-12 weeks at a minimum (or mid-point for shorter courses) and be offered impartial IAG, referrals or interventions dependant on the outcomes.</li>
                      <li>At end of training, receive full IAG on progression and career development advice.</li>
                      <li>Have their destination and progression monitored at 3 and 6 months after the completion of the award.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Scope and Description */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Scope of the DTK Information Advice and Guidance (IAG) Service
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    The DTK IAG Service will apply to all clients of DTK.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Description of the DTK Information Advice and Guidance Service
                  </h4>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    DTK provides all clients with free and impartial Information Advice and Guidance in relation to operating, employing, and training in their chosen sector. Information Advice and Guidance is embedded within DTK services and delivered over six stages:
                  </p>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '25px',
                    marginBottom: '20px'
                  }}>
                    <h5 style={{ color: '#7B3F9E', fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
                      1. Engagement
                    </h5>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', margin: 0 }}>
                      As part of the engagement process to assist clients in making the right choice of suitable training programmes and referring applicants who do not currently meet eligibility and/or entry requirements.
                    </p>
                  </div>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '25px',
                    marginBottom: '20px'
                  }}>
                    <h5 style={{ color: '#7B3F9E', fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
                      2&3. Enrolment & Induction
                    </h5>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', margin: 0 }}>
                      At the commencement of DTK programmes via comprehensive information at induction, and the use of diagnostic assessment, KSB assessment, Occupational Map, and recognised prior learning, to agree appropriate individual learning plans.
                    </p>
                  </div>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '25px',
                    marginBottom: '20px'
                  }}>
                    <h5 style={{ color: '#7B3F9E', fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
                      4&5. Ongoing delivery of IAG & Pastoral Support
                    </h5>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', margin: 0 }}>
                      During training as part of DTK' strategy to retain learners on programmes, and to provide appropriate and ongoing guidance that gives learners the best opportunity to complete the agreed qualifications/apprenticeship standard throughout the award and during progress reviews.
                    </p>
                  </div>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '25px',
                    marginBottom: '0'
                  }}>
                    <h5 style={{ color: '#7B3F9E', fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
                      6. Career & Progression
                    </h5>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', margin: 0 }}>
                      On exit/completion of DTK programmes to support learners to progress into relevant employment, higher education, or to further advance their career prospects.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resources and Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    DTK provides the following resources in respect of delivery of the IAG service:
                  </h3>
                  
                  <ol style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '40px' }}>
                    <li>Information of opportunities and programmes in relation to relevant sectors.</li>
                    <li>Guidance on the right provision following an assessment of training needs.</li>
                    <li>Pastoral support and guidance on-programme to assist retention of learners.</li>
                    <li>Information on additional support and referral procedures.</li>
                    <li>Information Advice and Guidance on career enhancement or other training options during and on completing DTK programmes.</li>
                    <li>Staff with the relevant knowledge and experience.</li>
                  </ol>

                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Responsibilities
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK Student Services and Assessors are responsible for providing ongoing information advice and guidance to prospective customers, employers, and applicants on recruitment to DTK training programmes. Assessors, Tutors, Mentors, Programme Managers, Training Centre Managers, and staff provide learners and employers with on programme information and support to enable them to successfully work with and complete their qualifications or apprenticeship standards. Assessors and recruitment advisers provide learners with guidance on and for 6 months after their exit from DTK programmes in relation to employment opportunities and career advancement.
                  </p>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    DTK Staff such as Programme Staff, Recruitment Staff, Audit and Compliance Staff, Internal Quality Assurance Staff and Director have the responsibility for line managing of IAG services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Quality Assurance & Evaluation */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Quality Assurance & Evaluation
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The provision of IAG services is quality assured via the collection and analysis of employer and participant feedback, and analysis of key performance data in respect of learner recruitment, retention, achievement, and progression. DTK Managers will be responsible for monitoring the front-line delivery, including the observation of the IAG service, and identifying areas for continuous improvement.
                  </p>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The outcomes from feedback and from DTK Managers will be subject to discussion at bi-monthly standardisation, IQA and Management Meetings and will be incorporated into our annual self-assessment report (SAR) and quality improvement plan (QIP).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits of Information, Advice & Guidance */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Benefits of Information, Advice & Guidance
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Being provided with the right information, advice and guidance (IAG) means the learner is equipped to make the best decisions about training, education and employment options.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    In today&apos;s lifelong learning environment, it is never too late to shift direction or learn new, marketable skills and make the most of your potential.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    Why is Information, Advice and Guidance important?
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Information, Advice and Guidance perform a vital role in the overall success of apprenticeship programmes. These tools assist individuals to have a better understanding of their interests, strengths, weaknesses, values and beliefs.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    IAG gives individuals the tools to make well-informed employment choices, find appropriate apprenticeship opportunities and increase the potential for long-term career and personal development.
                  </p>

                  <div style={{ marginBottom: '25px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '10px' }}>
                      Employment/Education Guidance
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px' }}>
                      IAG provides key information and guidance to individuals considering apprenticeships or vocational training. It helps them recognise the different employment or education paths presented, the skills required, and the potential benefits of seeking an apprenticeship or vocational training.
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                      Guidance on job search techniques, CV writing and interview skills can also increase an individual&apos;s chances of successfully securing a job or internship.
                    </p>
                  </div>

                  <div style={{ marginBottom: '25px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '10px' }}>
                      Informed Decision-Making
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px' }}>
                      IAG can assist individuals in setting clear, realistic and achievable employment and personal goals. This is critical in creating a sense of direction and motivation. IAG supports people to navigate different employment options by providing information about diverse employment and career paths, and importantly, the advantages and disadvantages of each.
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                      It ensures that individuals are aware of the various apprenticeship opportunities, enabling them to choose the one that aligns with their skills, interests and long-term career goals.
                    </p>
                  </div>

                  <div style={{ marginBottom: '25px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '10px' }}>
                      Pairing Skills to Opportunities
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px' }}>
                      IAG assists in pairing an individual&apos;s skills, abilities and experience to suitable apprenticeships and/or vocational courses. It can help individuals understand the skills and competencies required for their chosen employment pathways and offer recommendations for skills development and improvement.
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                      This is crucial for the success of apprenticeships, as it ensures that people are positioned in roles where they are likely to flourish and contribute effectively.
                    </p>
                  </div>

                  <div style={{ marginBottom: '0' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', marginBottom: '10px' }}>
                      Support Throughout the Apprenticeship
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                      IAG does not end with the selection of an apprenticeship. It continues to provide support and guidance during the apprenticeship and vocational journey. This includes assisting apprentices to set goals, track progress and address any challenges that may arise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* The Learner Journey Diagram */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0',
                  overflow: 'hidden'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '30px', textAlign: 'center' }}>
                    The Learner Journey and related IAG service
                  </h3>

                  {/* Desktop View */}
                  <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }} className="d-none d-lg-flex">
                    {/* Left Column - Learner/Employer Journey */}
                    <div style={{ flex: '0 0 180px', position: 'relative' }}>
                      <div style={{ 
                        backgroundColor: '#f8fafc',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '2px solid #7B3F9E',
                        marginBottom: '15px',
                        textAlign: 'center'
                      }}>
                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#1e293b', fontWeight: '700' }}>Learner/Employer Journey</p>
                        <p style={{ margin: 0, fontSize: '0.75rem', color: '#64748b', fontWeight: '600' }}>IAG Resources</p>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {[
                          'Organisational Needs Analysis (ONA), Training Needs Analysis(TNA), IAG, Recruitment, Engagement',
                          'Enrolment Process',
                          'Learner Induction',
                          'Assessment and Review & Teaching and Learning',
                          'Pastoral Support, Retention & Intervention Process',
                          'Achievement and Progression'
                        ].map((stage, index) => (
                          <React.Fragment key={index}>
                            <div style={{ 
                              backgroundColor: '#fff',
                              padding: '18px 12px',
                              borderRadius: '8px',
                              border: '2px solid #1e293b',
                              textAlign: 'center',
                              minHeight: '110px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              position: 'relative'
                            }}>
                              <p style={{ margin: 0, fontSize: '0.85rem', color: '#1e293b', fontWeight: '500', lineHeight: '1.4' }}>
                                {stage}
                              </p>
                              {/* Arrow pointing right to middle column */}
                              <div style={{
                                position: 'absolute',
                                right: '-30px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                fontSize: '1.5rem',
                                color: '#7B3F9E',
                                fontWeight: 'bold'
                              }}>→</div>
                            </div>
                            {index < 5 && (
                              <div style={{ textAlign: 'center', margin: '-8px 0' }}>
                                <div style={{ fontSize: '1.3rem', color: '#64748b' }}>↓</div>
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>

                    {/* Middle Column - IAG Service Details */}
                    <div style={{ flex: 1, position: 'relative' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '50px' }}>
                        {[
                          {
                            content: 'DTK promote programmes to learners & employers. DTK website provides IAG on the services offered. Employer ONA, TNA, and individual applicant IAGservices are carried out to ensure the suitability of course content, eligibility, and Key Performance Indicators (KPI’s). Applicants who do not meet theentry / eligibility requirements are signposted to the relevant agencies. Applicants who meet criteria are invited to complete a H&S Risk assessment or diagnostic assessments. If required, the employer vacancy service is utilised.'
                          },
                          {
                            content: 'Recruitment consultant reviews learner’s skills and technical ability through Knowledge Skills and Behaviours assessment, diagnostic assessments, and prior attainment records. A meeting is arranged with the employer and learner to provide further information about DTK, the programmes and appropriate sectors. Successful applicants are provided further IAG on their chosen career path, employment, and qualifications or apprenticeship programme. Enrolment Paperwork is then completed.'
                          },
                          {
                            content: 'Analysis of Initial assessments, diagnostic assessments and KSB results and Individual Learning Plan created, identifying any area for support. Demonstration of E-portfolio provided including where to find the wellbeing and support documents. Confirm they have read and understood the policies and procedures in the handbooks. Information on the Apprenticeship course content and expectations are explained in full. Learner completes a VARK learning style screening and skills scans.'
                          },
                          {
                            content: 'Every 12 weeks assessors will review learner progress with both the learner and employer. Monitoring KPI’s, equality and diversity, safeguarding, IAG and agree action plans to ensure learner progress is maintained and supported. Employers are provided with reports specifying attendance, progression, and achievement.'
                          },
                          {
                            content: 'Mentors are provided for all learners on programme. 12-weekly reviews are carried out to provide support and IAG. An analysis of the reviews is completed to identify any additional support needs, retention, and Intervention processes to be applied to any learner at risk of leaving the programme or whose level of progression is low. Analysis of complaints and feedback processes in place to address any learner /employer concerns and improve the service.'
                          },
                          {
                            content: 'Assessors will provide IAG to learners reaching the end of their programme. Employer report specifying achievement and progression routes. Progression opportunities will be discussed, and final skills scan completed. Additional destination checks are held at 3 and 6 months after completion / exit.'
                          }
                        ].map((section, index) => (
                          <div key={index} style={{ 
                            backgroundColor: '#F5EBFA',
                            padding: '18px',
                            borderRadius: '8px',
                            border: '2px solid #7B3F9E',
                            minHeight: '110px',
                            position: 'relative'
                          }}>
                            <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#1e293b', fontWeight: '700' }}>
                              {section.title}
                            </p>
                            <p style={{ margin: 0, fontSize: '0.75rem', color: '#475569', lineHeight: '1.5' }}>
                              {section.content}
                            </p>
                            {/* Arrow pointing right to resources column */}
                            <div style={{
                              position: 'absolute',
                              right: '-30px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              fontSize: '1.5rem',
                              color: '#7B3F9E',
                              fontWeight: 'bold'
                            }}>→</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Right Column - IAG Resources */}
                    <div style={{ flex: '0 0 180px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '50px' }}>
                        {[
                          'ONA Form TNA Form Eligibility Guide Institute for Apprenticeship website DTK website Employer Guide ESFA Apprenticeship Service and guides Marketing materials Find an Apprenticeship service Guide Guide to finding employment Interview preparation guide H&S / E&D Documents Employer Handbook Vacancy Form',
                          'Online Diagnostic Assessments KSB Assessment Personal Learning Record Student Handbook + Wellbeing Resourcem Staying Safe in UK Guide Smart Assessor Guide Health and Safety Booklet Discord User Guide Prevent Guide Definitions of common op',
                          'E-Portfolio Individual Learning Plan Awarding Body’s Standards Institute for Apprenticeship Occupational Standard Institute for Apprenticeship Assessment Plan Handbooks Wellbeing and support resources Course Outline DTK website VARK Questionnaire Skills Scan assessment Referral Form EPA Factsheets',
                          'Learner progress review Learner Feedback report Employer Feedback report SEND Monitoring Workplace Needs Monitoring Support Form Referral Form',
                          'List of referral agencies Retention and intervention process Learner review documents Complaints procedure Support Forms',
                          'ILP Exit review for progression Evaluation of service surveys Destination Questionnaires'
                        ].map((resources, index) => (
                          <div key={index} style={{ 
                            backgroundColor: '#fff',
                            padding: '18px 12px',
                            borderRadius: '8px',
                            border: '2px solid #64748b',
                            minHeight: '110px',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <p style={{ margin: 0, fontSize: '0.7rem', color: '#475569', lineHeight: '1.4' }}>
                              {resources}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Mobile/Tablet View - Stacked */}
                  <div className="d-lg-none">
                    {[
                      {
                        stage: 'Organisational Needs Analysis (ONA), Training Needs Analysis(TNA), IAG, Recruitment, Engagement',
                        service: 'Initial Assessment & Recruitment',
                        serviceDetail: 'DTK promote programmes to learners & employers. DTK website provides IAG on the services offered. Employer ONA, TNA, and individual applicant IAG services are carried out to ensure the suitability of applicants and programmes.',
                        resources: 'ONA Form, TNA Form, IAG Support forms, Institute for Apprenticeship website, DTK website, ESFA Apprenticeship service and guides, Marketing materials'
                      },
                      {
                        stage: 'Enrolment Process',
                        service: 'Enrolment & Induction',
                        serviceDetail: 'Recruitment consultant reviews learner\'s skills and progress. A meeting is arranged with the learner and the employer to introduce and inform about DTK, the programmes and appropriate sectors.',
                        resources: 'Online Diagnostic Assessments, KSB Assessment, Safeguarding Policies, Health and Safety Booklet'
                      },
                      {
                        stage: 'Learner Induction',
                        service: 'Individual Learning Plans',
                        serviceDetail: 'Analysis of initial assessments and Individual Learning Plan created, identifying any area for support. ILP accounts for learner progress and pastoral support needs.',
                        resources: 'Individual Learning Plan, Assessment plan, Prior learning form, Wellbeing and support resources'
                      },
                      {
                        stage: 'Assessment and Review & Teaching and Learning',
                        service: 'Progress Reviews',
                        serviceDetail: 'Every 12 weeks assessors will review learner progress with both the learner and employer. Reviews are used to monitor attendance, progression, and achievement.',
                        resources: 'Learner progress review, Learner feedback report, SWOT Monitoring, Attendance review'
                      },
                      {
                        stage: 'Pastoral Support, Retention & Intervention Process',
                        service: 'Retention & Pastoral Support',
                        serviceDetail: '12 weekly reviews carried out to provide support and IAG. Analysis of complaints and feedback processes in place to address concerns.',
                        resources: 'List of referral agencies, Retention process, Learner review documents, Support Forms'
                      },
                      {
                        stage: 'Achievement and Progression',
                        service: 'Career Guidance',
                        serviceDetail: 'Assessors provide IAG to learners reaching the end of their programme. Progression opportunities discussed and skills checks held at 3 and 6 months after completion.',
                        resources: 'IAG talk review for progression, Career surveys, Destination Questionnaires'
                      }
                    ].map((item, index) => (
                      <div key={index} style={{ marginBottom: '30px' }}>
                        <div style={{ 
                          backgroundColor: '#fff',
                          padding: '15px',
                          borderRadius: '8px',
                          border: '2px solid #1e293b',
                          marginBottom: '15px',
                          textAlign: 'center'
                        }}>
                          <p style={{ margin: 0, fontSize: '0.9rem', color: '#1e293b', fontWeight: '600' }}>
                            {item.stage}
                          </p>
                        </div>
                        <div style={{ textAlign: 'center', margin: '10px 0', fontSize: '1.3rem', color: '#7B3F9E' }}>↓</div>
                        <div style={{ 
                          backgroundColor: '#F5EBFA',
                          padding: '15px',
                          borderRadius: '8px',
                          border: '2px solid #7B3F9E',
                          marginBottom: '15px'
                        }}>
                          <p style={{ margin: '0 0 8px 0', fontSize: '0.95rem', color: '#1e293b', fontWeight: '700' }}>
                            {item.service}
                          </p>
                          <p style={{ margin: 0, fontSize: '0.85rem', color: '#475569', lineHeight: '1.5' }}>
                            {item.serviceDetail}
                          </p>
                        </div>
                        <div style={{ textAlign: 'center', margin: '10px 0', fontSize: '1.3rem', color: '#7B3F9E' }}>↓</div>
                        <div style={{ 
                          backgroundColor: '#fff',
                          padding: '15px',
                          borderRadius: '8px',
                          border: '2px solid #64748b'
                        }}>
                          <p style={{ margin: 0, fontSize: '0.85rem', color: '#475569', lineHeight: '1.5' }}>
                            {item.resources}
                          </p>
                        </div>
                        {index < 5 && <div style={{ textAlign: 'center', margin: '20px 0', fontSize: '1.5rem', color: '#64748b' }}>↓</div>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default CollegeIAGPolicy;